module.exports = __webpack_public_path__ + "public/img/img-3.60c63d7c.jpg";